// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"1abb2f67","453":"adedf119","965":"d4551fac"}[chunkId] + ".chunk.js";
};